import React, { useState, useEffect, useMemo, useCallback } from "react"
import { Table, Col, Row, Modal, ModalHeader, ModalBody, Spinner } from "reactstrap"
import api from "API/Api"
import SweetAlert from "react-bootstrap-sweetalert"
import loader from "./../../assets/loading/loader.gif"

const BusinessVendors = () => {
  const [vendors, setVendors] = useState([])
  const [dataLoaded, setDataLoaded] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [checkedItems, setCheckedItems] = useState({})
  const [parentChecked, setParentChecked] = useState(false)
  const [confirm_multiple_alert, setConfirm_multiple_alert] = useState(false)
  const [search, setSearch] = useState("")
  // Add/Edit modal
  const [modalOpen, setModalOpen] = useState(false)
  const [editId, setEditId] = useState(null)
  const [formName, setFormName] = useState("")
  const [saving, setSaving] = useState(false)
  const [formResult, setFormResult] = useState(null)

  const arr = r => Array.isArray(r.data.data) ? r.data.data : r.data.data?.data || []
  const fetchData = useCallback(async () => {
    try { const res = await api.get("business-vendors-list"); setVendors(arr(res)) } catch (e) { console.error(e) }
    setDataLoaded(true)
  }, [])
  useEffect(() => { fetchData() }, [fetchData])

  const handleMultiDelete = async () => { const ids = Object.keys(checkedItems).filter(k => checkedItems[k]); if (!ids.length) return; try { await api.post("delete-multiple-business-vendors", { items: ids }); setCheckedItems({}); setParentChecked(false); fetchData() } catch (e) { } }
  const handleCheckbox = id => { setCheckedItems(prev => { const n = { ...prev, [id]: !prev[id] }; setParentChecked(vendors.length > 0 && vendors.every(v => n[v.id])); return n }) }
  const handleParentCheckbox = () => { const n = !parentChecked; setParentChecked(n); const items = {}; vendors.forEach(v => { items[v.id] = n }); setCheckedItems(items) }
  const selectedCount = Object.values(checkedItems).filter(Boolean).length

  const filtered = useMemo(() => vendors.filter(v => (v.name || "").toLowerCase().includes(search.toLowerCase())), [vendors, search])

  const openAdd = () => { setEditId(null); setFormName(""); setFormResult(null); setModalOpen(true) }
  const openEdit = v => { setEditId(v.id); setFormName(v.name || ""); setFormResult(null); setModalOpen(true) }

  const handleSave = async () => {
    if (!formName.trim()) { setFormResult({ success: false, message: "Name is required" }); return }
    setSaving(true); setFormResult(null)
    try {
      if (editId) {
        await api.put("update-business-vendor/" + editId, { name: formName.trim() })
        setFormResult({ success: true, message: "Updated!" })
      } else {
        await api.post("create-business-vendor", { name: formName.trim() })
        setFormResult({ success: true, message: "Created!" })
      }
      fetchData(); setFormName(""); setEditId(null)
      setTimeout(() => setModalOpen(false), 800)
    } catch (e) {
      setFormResult({ success: false, message: e?.response?.data?.message || "Failed" })
    }
    setSaving(false)
  }

  const handleDelete = async id => {
    try { await api.delete("delete-business-vendor/" + id); fetchData() } catch (e) { }
  }

  const exportCSV = () => {
    const h = ["S.No", "Vendor Name", "Created"]
    const r = filtered.map((v, i) => [i + 1, v.name, v.created_at])
    const csv = [h, ...r].map(r => r.map(c => `"${(c || "").toString().replace(/"/g, '""')}"`).join(",")).join("\n")
    const b = new Blob([csv], { type: "text/csv" }); const a = document.createElement("a"); a.href = URL.createObjectURL(b); a.download = `business_vendors_${new Date().toISOString().slice(0, 10)}.csv`; a.click()
  }

  const ib = (bg, icon, title, onClick, dis) => <button title={title} onClick={onClick} disabled={dis} style={{ width: "32px", height: "32px", borderRadius: "4px", background: bg, color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer", opacity: dis ? 0.5 : 1 }}><i className={`fas ${icon}`}></i></button>

  return (<>
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <h4 style={{ margin: 0 }}>Business Vendors</h4>
          {ib("#28a745", "fa-plus", "Add Vendor", openAdd, false)}
          {ib("#dc3545", "fa-trash", selectedCount > 0 ? `Delete ${selectedCount}` : "Select items", () => { if (selectedCount > 0) setConfirm_multiple_alert(true); else alert("Select items first") }, false)}
          {ib("#17a2b8", "fa-download", "Export", exportCSV, !filtered.length)}
        </div>
        <div style={{ display: "flex", alignItems: "center" }}><input type="text" className="form-control form-control-sm" placeholder="Search vendors..." style={{ width: "200px", borderRadius: "4px 0 0 4px" }} value={search} onChange={e => setSearch(e.target.value)} /><button className="btn btn-primary btn-sm" style={{ borderRadius: "0 4px 4px 0", height: "31px" }}><i className="fas fa-search"></i></button></div>
      </div>
      <Row className="mb-3 mt-2">{[
        { label: "Total Vendors", value: filtered.length, icon: "fa-store", color: "#6366f1" },
      ].map((c, i) => <Col md={4} sm={6} key={i}><div style={{ background: "#fff", borderRadius: "10px", padding: "14px 16px", borderLeft: `4px solid ${c.color}`, boxShadow: "0 1px 3px rgba(0,0,0,0.08)", display: "flex", alignItems: "center", gap: "12px", marginBottom: "8px" }}><div style={{ width: "40px", height: "40px", borderRadius: "8px", background: c.color + "15", display: "flex", alignItems: "center", justifyContent: "center" }}><i className={`fas ${c.icon}`} style={{ color: c.color, fontSize: "16px" }}></i></div><div><div style={{ fontSize: "20px", fontWeight: "700", color: "#1e293b" }}>{c.value}</div><div style={{ fontSize: "11px", color: "#6c757d", textTransform: "uppercase", letterSpacing: "0.5px" }}>{c.label}</div></div></div></Col>)}</Row>
      <div className="table-responsive"><Table className="table mb-0 dairyTbl"><thead><tr>
        <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckbox} /></th>
        <th>S.NO</th><th>Vendor Name</th><th>Created</th><th>Actions</th>
      </tr></thead><tbody>
          {!dataLoaded ? <tr><td colSpan={5}><img className="loaderImg" src={loader} alt="Loading" /></td></tr>
            : filtered.length > 0 ? filtered.map((v, i) => <tr key={v.id}>
              <td><input type="checkbox" checked={!!checkedItems[v.id]} onChange={() => handleCheckbox(v.id)} /></td>
              <td>{i + 1}</td><td style={{ fontWeight: "600" }}>{v.name}</td>
              <td>{v.created_at ? new Date(v.created_at).toLocaleDateString("en-IN") : "—"}</td>
              <td><div style={{ display: "flex", gap: "4px" }}>
                <button title="Edit" onClick={() => openEdit(v)} style={{ width: "28px", height: "28px", borderRadius: "4px", background: "#0d6efd", color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "12px", cursor: "pointer" }}><i className="fas fa-edit"></i></button>
                <button title="Delete" onClick={() => handleDelete(v.id)} style={{ width: "28px", height: "28px", borderRadius: "4px", background: "#dc3545", color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "12px", cursor: "pointer" }}><i className="fas fa-trash"></i></button>
              </div></td></tr>)
              : <tr><td colSpan={5} className="text-center py-4"><i className="fas fa-inbox fa-2x text-muted mb-2 d-block"></i>No business vendors found</td></tr>}
      </tbody></Table></div>
    </div>

    {/* Add/Edit Modal */}
    <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} size="md">
      <ModalHeader toggle={() => setModalOpen(false)}><i className={`fas ${editId ? "fa-edit" : "fa-plus"} me-2`} style={{ color: editId ? "#0d6efd" : "#28a745" }}></i>{editId ? "Edit" : "Add"} Business Vendor</ModalHeader>
      <ModalBody>
        <div className="mb-3"><label className="form-label fw-bold">Vendor Name *</label>
          <input type="text" className="form-control" placeholder="Enter vendor name" value={formName} onChange={e => setFormName(e.target.value)} /></div>
        {formResult && <div className={`alert alert-${formResult.success ? "success" : "danger"} py-2`} style={{ fontSize: "13px" }}>{formResult.message}</div>}
        <div className="text-end"><button className="btn btn-primary btn-sm" onClick={handleSave} disabled={saving}>
          {saving ? <><Spinner size="sm" /> Saving...</> : <><i className="fas fa-save me-1"></i>{editId ? "Update" : "Save"}</>}</button></div>
      </ModalBody>
    </Modal>

    {confirm_multiple_alert && <SweetAlert title={`Delete ${selectedCount} items?`} warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger" onConfirm={() => { handleMultiDelete(); setConfirm_multiple_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Deleted.") }} onCancel={() => setConfirm_multiple_alert(false)}>You won't be able to revert this!</SweetAlert>}
    {success_dlg && <SweetAlert success title={dynamic_title} onConfirm={() => setsuccess_dlg(false)}>{dynamic_description}</SweetAlert>}
  </>)
}
export default BusinessVendors
